import { useEffect, useState } from "react";
import CreateStudentResource from "./studentResourceCreate";
import { connect, useDispatch } from "react-redux";
import EditStudentResource from "./studentResourceEdit";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getStudentResources,
  getStudentResource,
  deleteStudentResource,
} from "../../../../../action/masters/studentResourceActionCreator";
import { baseURL } from "../../../../../constants/commonConstants";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  IStudentResourceIndex,
  IStudentResourceData,
} from "../../../../../models/master/studentResource";
import { setStudentResources } from "../../../../../store/slices/master/studentResourceSlice";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";

const StudentResourceIndex = (props: IStudentResourceIndex) => {
  const {
    getStudentResources,
    studentResources,
    getStudentResource,
    studentResource,
    deleteStudentResource,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getStudentResource(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const getAllStudentResources = async () => {
    setIsLoading(true);
    try {
      await getStudentResources();
    } finally {
      setIsLoading(false);
    }
  };

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteStudentResource(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllStudentResources();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  useEffect(() => {
    getAllStudentResources();
    return () => {
      dispatch(setStudentResources([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Student Resource</h2>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={handleCreateOpen}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : studentResources && studentResources.length > 0 ? (
            studentResources.map((studentResource: IStudentResourceData) => {
              return (
                <li className="admin-card">
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(studentResource.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(studentResource.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <a href={studentResource.url} target="_blank">
                    <div className="btm">
                      <div className="img">
                        <img
                          src={
                            studentResource.image
                              ? baseURL + studentResource.image
                              : ""
                          }
                        />
                      </div>
                      <h2>{studentResource.name}</h2>
                      <p>{studentResource.description.slice(0, 30)}</p>
                    </div>
                  </a>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>

      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <CreateStudentResource
          setShowCreate={handleCreateClose}
          getAllStudentResources={() => getAllStudentResources()}
        />
      </ReactModal>
      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
        >
          <EditStudentResource
            setShowEdit={handleEditClose}
            getAllStudentResources={() => getAllStudentResources()}
            studentResource={studentResource}
          />
        </ReactModal>
      )}
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};
const mapDispatchToProps = {
  getStudentResources: () => getStudentResources(),
  getStudentResource: (id: number) => getStudentResource(id),
  deleteStudentResource: (id: number, callBack: Function) =>
    deleteStudentResource(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    studentResources: state.studentResource.studentResources,
    studentResource: state.studentResource.studentResource,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentResourceIndex);
